import Column from "rc-footer/lib/column";
import React, { Component } from "react";
import CanvasJSReact from "../canvas/canvasjs.react";
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
class LeadsByMonthGraph extends Component {
  constructor() {
    super();
    this.toggleDataSeries = this.toggleDataSeries.bind(this);
    this.addSymbols = this.addSymbols.bind(this);
  }

  addSymbols(e) {
    var suffixes = ["", "K", "M", "B"];
    var order = Math.max(
      Math.floor(Math.log(Math.abs(e.value)) / Math.log(1000)),
      0
    );
    if (order > suffixes.length - 1) order = suffixes.length - 1;
    var suffix = suffixes[order];
    return CanvasJS.formatNumber(e.value / Math.pow(1000, order)) + suffix;
  }

  toggleDataSeries(e) {
    if (typeof e.dataSeries.visible === "undefined" || e.dataSeries.visible) {
      e.dataSeries.visible = false;
    } else {
      e.dataSeries.visible = true;
    }
    this.chart.render();
  }

  render() {
    const options = {
      zoomEnabled: true,
      panEnabled: true,
      animationEnabled: true,
      colorSet: "colorSet2",

      title: {
        // text: "Monthly Sales"
      },
      axisX: {
        valueFormatString: "MMMM",
        interval: 1,
      },
      axisY: {
        prefix: "",
        // labelFormatter: this.addSymbols
      },
      toolTip: {
        shared: true,
      },
      legend: {
        cursor: "pointer",
        itemclick: this.toggleDataSeries,
        verticalAlign: "top",
      },
      // axisY2: {
      // 	includeZero: false,
      // 	title: "Secondary Y - Axis"
      // },
      // axisY: {
      // 	title: "Primary Y - Axis"
      // },

      height: this.props.height,
      data: [
        {
          type: this.props.graphType,
          axisYIndex: 0,
          name: this.props.title ? this.props.title : 'Error',
          showInLegend: true,
          yValueFormatString: "###0",
          // axisYType: "secondary",
          dataPoints: this.props.db,
          color: this.props.color,
        },
        {
          type: this.props.graphType,
          axisYIndex: 1,
          axisYType: "secondary",
          name: "Profit",
          // markerBorderColor: "white",
          // markerBorderThickness: 2,
          showInLegend: true,
          yValueFormatString: "$#",
          // axisYType: "secondary",

          dataPoints: this.props.db2,
          color: this.props.color2,
        },
      ],
    };
    return (
      <div>
        <CanvasJSChart options={options} onRef={(ref) => (this.chart = ref)} />
        {/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
      </div>
    );
  }
}
export default LeadsByMonthGraph;
